var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';
var MaxValueCheckDirective = /** @class */ (function () {
    function MaxValueCheckDirective() {
    }
    MaxValueCheckDirective_1 = MaxValueCheckDirective;
    MaxValueCheckDirective.prototype.validate = function (control) {
        if (!control.value && control.value !== 0) {
            return undefined;
        }
        var value = +control.value;
        if (value < this.minNumber || value > this.maxNumber) {
            return { 'minValue': 'error' };
        }
        if (this.moreThanNumber > value &&
            (this.moreThanNumber || this.moreThanNumber === 0) &&
            (value || value === 0)) {
            return { 'lessThan': 'error' };
        }
        return undefined;
    };
    var MaxValueCheckDirective_1;
    __decorate([
        Input()
    ], MaxValueCheckDirective.prototype, "moreThanNumber", void 0);
    __decorate([
        Input()
    ], MaxValueCheckDirective.prototype, "minNumber", void 0);
    __decorate([
        Input()
    ], MaxValueCheckDirective.prototype, "maxNumber", void 0);
    MaxValueCheckDirective = MaxValueCheckDirective_1 = __decorate([
        Directive({
            selector: '[maxValueCheck]',
            providers: [{
                    provide: NG_VALIDATORS,
                    useExisting: MaxValueCheckDirective_1,
                    multi: true
                }]
        })
    ], MaxValueCheckDirective);
    return MaxValueCheckDirective;
}());
export { MaxValueCheckDirective };
